import 'intersection-observer';
import lozad from 'lozad';

const selector = '.js-lazy'
const prioritySelector = '.js-lazy--priority'

const els = document.querySelectorAll(selector)
const priorityEls = document.querySelectorAll(`${selector}${prioritySelector}`)

const options = {
	rootMargin: '0px 0px 500px 0px',
  threshold: 0.1,
}

export const observer = lozad(
	els,
	options
)

observer.observe();

// trigger all on load

[...priorityEls].forEach(el => observer.triggerLoad(el))

export default observer